import axios from 'axios';

axios.defaults.baseURL = '/api';

axios.interceptors.response.use(function (res) {
    return res.data;
}, function (error) {

    if (!error.response || !error.response.data) {
        return Promise.reject(error);
    }

    return Promise.reject(error.response.data);
});

export default axios;